import React from "react";
import { Button, InputAdornment, MenuItem, TextField } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import TitleIcon from "@mui/icons-material/Title";
import DescriptionIcon from "@mui/icons-material/Description";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CategoryIcon from "@mui/icons-material/Category";

export default function CourseForm({
  formData,
  handleChangeInputCourse,
  handleInsertCourse,
  isEditing,
  handleUpdateCourse,
}) {
  return (
    <div className="p-6 max-w-3xl mx-auto bg-white shadow-lg rounded-lg mb-[50px]">
      <h2 className="text-2xl font-bold text-center mb-6">
        {isEditing ? "Cập nhật thông tin khóa học" : "Tạo khóa học mới"}
      </h2>
      <div className="mb-5 flex justify-around flex-wrap">
        <TextField
          label="Tiêu đề *"
          name="title"
          value={formData?.title}
          className="md:w-[300px] w-[100%] lg:mb-0 mb-5 label-text"
          onChange={handleChangeInputCourse}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <TitleIcon />
              </InputAdornment>
            ),
          }}
          variant="standard"
        />
        <TextField
          label="Giá *"
          name="price"
          type="number"
          value={formData?.price}
          onChange={handleChangeInputCourse}
          className="md:w-[300px] w-[100%] label-text"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AttachMoneyIcon />
              </InputAdornment>
            ),
          }}
          variant="standard"
          placeholder="0"
        />
      </div>

      <div className="mb-5 flex justify-around flex-wrap">
        <TextField
          label="Mô tả *"
          name="description"
          value={formData?.description}
          onChange={handleChangeInputCourse}
          className="md:w-[300px] w-[100%] lg:mb-0 mb-5 label-text"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <DescriptionIcon />
              </InputAdornment>
            ),
          }}
          variant="standard"
          multiline
          rows={3}
        />
        <TextField
          select
          label="Loại khóa học *"
          name="type"
          value={formData?.type || ""}
          onChange={handleChangeInputCourse}
          className="md:w-[300px] w-[100%] label-text"
          variant="standard"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <CategoryIcon />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            shrink: true,
          }}
        >
          {["TSA", "THPT"].map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </div>


      <div className="mb-5 flex justify-around flex-wrap px-[130px]">
        {isEditing ? (
          <Button
            variant="contained"
            component="label"
            className="label-text md:w-[250px] w-[100%] py-[10px]"
            startIcon={<CloudUploadIcon />}
            onClick={handleUpdateCourse}
          >
            Cập nhật khóa học
          </Button>
        ) : (
          <Button
            variant="contained"
            component="label"
            className="label-text md:w-[200px] w-[100%] py-[10px]"
            startIcon={<CloudUploadIcon />}
            onClick={handleInsertCourse}
          >
            Tạo khóa học
          </Button>
        )}
      </div>
    </div>
  );
}
